export default "__VITE_PUBLIC_ASSET__56128c2c__"